import { GridColumn as Column } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { NetworkTypeColumnMenu } from "../NetworkTypeColumnMenu";
import { ColumnMenu } from "../../../../../Layout/Grid/Filter/ColumnMenu";

export function OdcNetworkGridColumns() {
  return [
    <Column
      width="100px"
      key="Gsdb"
      field="Gsdb"
      title="ODC"
      filter="text"
      editable={false}
      resizable
      columnMenu={ColumnMenu}
    />,
    <Column
      width="200px"
      key="NetworkType"
      field="NetworkType"
      title="Container Network"
      filter="text"
      editable={false}
      resizable
      columnMenu={NetworkTypeColumnMenu}
    />,
  ];
}
